<template>
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 24C3.5 12.402 12.902 3 24.5 3C36.098 3 45.5 12.402 45.5 24C45.5 35.598 36.098 45 24.5 45C12.902 45 3.5 35.598 3.5 24Z"
      stroke="#172B54"
      stroke-width="2"
    />
    <path
      d="M26.2436 16.0343L33.8061 23.2531C34.0102 23.4478 34.1257 23.7176 34.1257 23.9999C34.1257 24.2822 34.0102 24.5516 33.8061 24.7467L26.2436 31.9654C25.8313 32.3575 25.1788 32.3427 24.7852 31.9305C24.3918 31.5223 24.4066 30.867 24.8201 30.4721L30.5221 25.0323H15.9057C15.3364 25.0323 14.874 24.5699 14.874 24.0006C14.874 23.4313 15.3364 22.9698 15.9057 22.9698H30.5194L24.8174 17.5299C24.4045 17.1343 24.3916 16.479 24.7826 16.0695C25.1779 15.657 25.7924 15.6424 26.2436 16.0343Z"
      fill="#172B54"
    />
  </svg>
</template>
